export enum PostponedCommissionsReport {
  UNRESOLVED = "UNRESOLVED",
  UNRESOLVED_INCLUDED_IN_BATCH = "UNRESOLVED_INCLUDED_IN_BATCH",
  RESOLVED = "RESOLVED"
}
